<p class="loader" *ngIf="auth.isLogin() && !isInitData">
    <img src="assets/loader.gif" alt="Загрузка..." />
</p>
<form *ngIf="auth.isLogin() && userCan" (submit)="update()">
    
    <change-terms-purchase-row *ngFor="let field of fields" [field]="field"></change-terms-purchase-row>
    
    <input type="submit" value="Обновить" class="btn btn-success" />
</form>
<div *ngIf="!auth.isLogin()">Необходимо авторизоваться</div>
<div *ngIf="isInitData && !userCan">У пользователя недостаточно прав</div>



// WEBPACK FOOTER //
// ./src/app/pages/change-terms-purchase/change-terms-purchase.component.html